import React from 'react';
import { Modal } from 'antd';

export default class AwardInfoModal extends React.Component {
	render() {
		return (
			<Modal
				onCancel={this.props.onCancel}
				visible={this.props.visible}
				footer={null}>
				
				<legend>Estimated Awards</legend>
				<p>
					Please note that your need and merit grants will be listed as “estimated” until the Scholarship Announcement date listed for your voyage. Estimated awards display the base, minimum amount of aid you can expect to receive from Semester at Sea. Should you receive additional Semester at Sea scholarships, your need based grant may be adjusted however your overall aid package will likely increase.
				</p>
				<br /><br />
				<legend>Cabin Adjustments</legend>
				<p>
					Please note that a cabin adjustment has been placed on your account due to our agreement with your home institution. This reduction has been applied to your account in the form of financial aid, to ensure that you are paying the cabin rate stipulated in our agreement with your institution.
				</p>

			</Modal>
		);
	}
}



// WEBPACK FOOTER //
// ./portal-components/Portal/Financial/FinancialAid/AwardInfoModal.jsx